/**
 * ShirtPreview — animated SVG t-shirt that scales as the user picks XS→3XL.
 */
import React from 'react';

const SCALE = { XS: 0.65, S: 0.75, M: 0.85, L: 0.95, XL: 1.05, '2XL': 1.15, '3XL': 1.25 };

export function ShirtPreview({ size }) {
  const scale = SCALE[size] || 0.85;
  return (
    <div className="flex items-center justify-center min-h-[120px] py-2"
      data-testid="shirt-preview">
      <svg viewBox="0 0 120 100"
        style={{
          width: 120 * scale,
          height: 100 * scale,
          filter: 'drop-shadow(0 12px 24px rgba(245,158,11,0.35))',
          transition: 'all 0.55s cubic-bezier(.2,.9,.3,1)',
        }}>
        <defs>
          <linearGradient id="shirt-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#CD040B" />
            <stop offset="100%" stopColor="#F59E0B" />
          </linearGradient>
        </defs>
        {/* T-shirt body + sleeves */}
        <path d="M36 12 L48 6 Q60 16 72 6 L84 12 L106 24 L98 38 L86 32 L86 96 L34 96 L34 32 L22 38 L14 24 Z"
          fill="url(#shirt-grad)"
          stroke="#0B0B0F"
          strokeWidth="1.5"
          strokeLinejoin="round" />
        {/* Collar */}
        <path d="M48 6 Q60 14 72 6"
          fill="none"
          stroke="#0B0B0F"
          strokeWidth="1.5"
          strokeLinecap="round" />
        {/* Size text */}
        <text x="60" y="64" textAnchor="middle"
          fontSize="20" fontWeight="900" fill="#fff"
          style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '0.02em' }}>
          {size || '—'}
        </text>
      </svg>
    </div>
  );
}
